import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import i18n from "../../I18n";
import { isPadOrMobile } from "utils/ScreenUtils";
import { enLocaleNumberFormatter } from "utils";
import { LevelUpgradeOptionType } from "utils/CustomEnums";
import './MoreUpgradeOptions.scss';


const SingleUpgradeOption = ({
  option
}) => {
  if (option.type === LevelUpgradeOptionType.ACCUMULATED_IN_X_DAYS) {
    return (
      <div className="single-option-container body-2">
        <div>
          {i18n.t("spendInXDays", { amount: enLocaleNumberFormatter(option.amount), day: option.day })}
        </div>
        <div>
          {i18n.t("haveSpentInXDays", { amount: enLocaleNumberFormatter(option.spent), day: option.day })}
        </div>
      </div>
    )
  };

  return (
    <div className="single-option-container body-2">
      <div>
        {i18n.t("singlePurchaseSpend", { amount: enLocaleNumberFormatter(option.amount) })}
      </div>
    </div>
  )
}

const MoreUpgradeOptions = ({
  language,
  upgradeOptions,
  showModal,
  close,
}) => {
  const isMobile = isPadOrMobile();

  return (
    <Modal
      show={showModal}
      onHide={close}
      className={`more-upgrade-options-modal ${isMobile ? "mobile-view" : ""}`}
      centered
    >
      <Modal.Body className="more-upgrade-options-modal-body">
        <div className="more-upgrade-options-title headline">
          {i18n.t("moreUpgradeOptionsTitle")}
        </div>
        <div className="more-upgrade-options-content body-1">
          {i18n.t(upgradeOptions.length === 1 ? "moreUpgradeOptionsContentSingle" : "moreUpgradeOptionsContent")}
        </div>

        <div className="more-upgrade-options">
          {
            upgradeOptions.map((option, index) => (
              <SingleUpgradeOption
                key={`option-${option.type}`}
                option={option}
              />
            ))
          }
        </div>

        <div className="ok-btn">
          <button
            className="right_btn button-large"
            onClick={close}
          >
            {i18n.t("ok")}
          </button>
        </div>
      </Modal.Body>
    </Modal>)
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  upgradeOptions: state.users.upgradeOptions,
});

export default connect(mapStateToProps)(MoreUpgradeOptions);
